const defaultCacheTimeOut = 30_000;

const _promiseCache = new Map<string, Promise<unknown>>();

/**
 * Creates a cached promise by key, on first call promise is initiated and returned.
 * If called a second time with same key, same promise will be returned.
 * When finished, cache will be reset after `cacheTimeout` (defaults to 30 seconds)
 */
const cachedPromise = <T>(
    keys: string | string[],
    executor: (
        resolve: (value: T | PromiseLike<T>) => void,
        reject: (reason?: unknown) => void
    ) => void,
    cacheTimout = defaultCacheTimeOut
): Promise<T> => {
    const key = Array.isArray(keys) ? keys.join("_") : keys;
    const cached = _promiseCache.get(key) as Promise<T> | undefined;
    if (cached) return cached;
    const promise = new Promise<T>(executor);
    _promiseCache.set(key, promise);
    promise
        .then(result => {
            setTimeout(() => {
                _promiseCache.delete(key);
            }, cacheTimout);
            return result;
        })
        .catch(rejection => {
            _promiseCache.delete(key);
            return rejection;
            //throw rejection;
        });
    return promise;
};

export { cachedPromise };
